export default __webpack_public_path__ + "static/media/icn-operatives-aspects-on.6612f4d3.svg";